import React from 'react';
import { IMAGES } from '../data/site';
import { CATALOG, lowestPrice } from '../data/catalog';
import { MAIN_WHATSAPP_MESSAGE } from '../data/messages';
import { formatMXN } from '../utils/currency';
import { WhatsAppButton } from './WhatsAppButton';
import { PerksStrip } from './PerksStrip';
export function Hero() {
  return <section className="bg-navy-900 text-white" data-id="element-65" data-mp="4n1jsn49o4qe">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 pb-8 pt-7 sm:px-6 sm:pb-14 sm:pt-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:items-center lg:gap-12" data-id="element-66" data-mp="129h0vnss70df">
        <div data-id="element-67" data-mp="x8jm7l6zcogo">
          <p className="mb-3 flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.16em] text-accent-500" data-id="element-68" data-mp="sbb1bcug66bq">
            <span className="guide-line h-px w-6" aria-hidden="true" data-id="element-69" data-mp="ncztf7npq5w5" />
            Bovedilla · Casetón · Vigueta
          </p>

          <h1 className="text-balance font-display text-[1.95rem] font-bold leading-[1.04] sm:text-5xl lg:text-[3.4rem]" data-id="element-70" data-mp="3d33gb2q0p1mv">
            Tu losa sin laberintos: bovedilla EPS desde <span className="text-accent-500" data-id="element-71" data-mp="3j7zc59vbxccg">$300</span> y entrega sin
            costo
          </h1>

          <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-steel-200 sm:mt-5 sm:text-lg" data-id="element-72" data-mp="3o7vjnj38jlwr">
            Deja de perder días entre proveedores, medidas y fletes. Arma tu pedido, ve tu precio al instante y
            recíbelo en tu obra en el Bajío.
          </p>

          <div className="mt-5 flex flex-col gap-2.5 sm:mt-7 sm:flex-row" data-id="element-73" data-mp="30i158x39ppae">
            <a href="#cotizador" className="inline-flex items-center justify-center rounded-md bg-accent-500 px-7 py-4 text-base font-semibold text-white shadow-lg shadow-black/30 transition-[background-color,transform] duration-150 ease-out hover:bg-accent-600 active:scale-[0.98] sm:text-lg" data-id="element-74" data-mp="30fya5yn9d5yt">
              Armar mi pedido y ver precio
            </a>
            <WhatsAppButton message={MAIN_WHATSAPP_MESSAGE} label="Cotizar por WhatsApp" location="hero" variant="white" size="lg" data-id="element-75" data-mp="2hl9td8q22cgd" />
          </div>
          <p className="mt-2.5 text-xs text-steel-400 sm:text-sm" data-id="element-76" data-mp="nbl58stuaue5">Respuesta rápida. Precios netos lista 2026.</p>

          <dl className="mt-6 grid grid-cols-3 gap-px overflow-hidden rounded-lg bg-white/10" data-id="element-77" data-mp="ibp02q9eowx0">
            {CATALOG.map(cat => <div key={cat.id} className="bg-navy-800 px-2.5 py-2.5 sm:px-4 sm:py-3" data-id="element-78" data-mp="deq6c8tnmrzc">
                <dt className="text-xs text-steel-400 sm:text-sm" data-id="element-79" data-mp="1azku1n7lcaq3">{cat.shortLabel} desde</dt>
                <dd className="font-display text-2xl font-semibold leading-tight text-white" data-id="element-80" data-mp="162ugp7n67t8d">
                  {formatMXN(lowestPrice(cat))}
                </dd>
              </div>)}
          </dl>
        </div>

        <div className="hidden lg:block" data-id="element-81" data-mp="x0uwk6gv0917">
          <img src={IMAGES.hero} alt="Equipo de OA LOSAS junto a bovedilla EPS en existencia" className="aspect-[4/5] w-full rounded-xl object-cover shadow-2xl shadow-black/40" loading="eager" data-id="element-82" data-mp="3lsp33cogahdw" />
        </div>
      </div>

      <div className="mx-auto max-w-content px-4 pb-6 sm:px-6 sm:pb-12" data-id="element-83" data-mp="1x7htx8b35sy8">
        <PerksStrip data-id="element-84" data-mp="21bfy3xf9pty5" />
      </div>
    </section>;
}